import * as React from "react";
import { connect } from "react-redux";

import i18n from "../../lib/i18n";
import { RootState } from "../../state";
import { companySelector, companyMembershipSectionsSelector } from "../selectors";
import { EntitiesMap, Company, CompanyMembership, CompanyMembershipSection } from "../entities";
import Translate from "../../common/components/Translate";
import { NavigatableSection, SectionInner, SectionTitle, SectionLink } from "./Section";
import { navFullPath } from "./HeaderNav";
import MembershipTeamList from "./MembershipTeamList";
import CompanyMembershipFeaturingsViewer from "../../company_memberships/components/CompanyMembershipFeaturingsViewer";

interface OwnProps {
  locale: string;
  editable?: boolean;
}

interface MappedProps {
  company: Company;
  featuredMemberships: CompanyMembership[];
  membershipSections: CompanyMembershipSection[];
  entities: EntitiesMap;
}

type Props = MappedProps & OwnProps;

const MembersSectionContainer: React.SFC<Props> = props => {
  const { company, featuredMemberships, membershipSections, entities, locale, editable } = props;

  return (
    <NavigatableSection id="members" displayName={i18n.translate("company.home.sections.members", { locale })}>
      <SectionInner>
        <SectionTitle>
          <Translate id="company.home.sections.members" />
          <SectionLink to={navFullPath(company, "/members")}>
            {editable ? (
              <Translate id="company.home.manage_members" />
            ) : (
              <Translate id="company.home.view_other_members" />
            )}
          </SectionLink>
        </SectionTitle>
        <CompanyMembershipFeaturingsViewer
          company={company}
          featuredMemberships={featuredMemberships}
          entities={entities}
          namespace="companies"
        />
      </SectionInner>
      <MembershipTeamList
        company={company}
        membershipSections={membershipSections}
        editable={editable}
        locale={locale}
      />
    </NavigatableSection>
  );
};

function mapStateToProps(state: RootState): MappedProps {
  return {
    company: companySelector(state)!,
    featuredMemberships: state.companies.members.draftFeaturedMemberships,
    membershipSections: companyMembershipSectionsSelector(state),
    entities: state.companies.entities,
  };
}

export default connect(mapStateToProps)(MembersSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/MembersSectionContainer.tsx